import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export default function LineCard({ item, managelineselectclick }) {
  const { t } = useTranslation();
  const msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);

  return (
    <li
      className="flex_grp_between mt-3"
      style={{ borderColor: `${item?.cmsisdn === msisdn ? 'red' : ''}` }}
      onClick={() => {
        managelineselectclick(item);
      }}
    >
      <div className="profile_info_v1">
        <div className="profile_info_v1_img profile_info_img1 align-self-center">
          <img
            src={
              item?.image ||
              process.env.PUBLIC_URL + '/assets/images/sprint16/ooredoo-sm-logo.svg'
            }
            alt=""
            title=""
          />
        </div>
        <div className="profile_info_v1_desc">
          <div className="flex_grp_align_center okw-line-clamp">
            <h3 className="okw-h1-title dir-ltrl">{item?.nickname || t('nickname')}</h3>
            {/* <a href='#/edit-manage-lines' className='img_btn img_btn_md'>
                                                <img src={process.env.PUBLIC_URL + '/assets/images/edit_red.svg'} alt="" title="" />
                                            </a> */}

            {/* <button
                            //   onClick={(e) => {
                            //     e.stopPropagation();
                            //     editManageLinesClick(x);
                            //   }}
                              className="img_btn img_btn_md"
                            >
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/edit_red.svg"
                                }
                                alt=""
                                title=""
                              />
                            </button> */}
          </div>
          {/* <h4
                            // onClick={(e) => {
                            //   e.stopPropagation();
                            //   managelineselectclick(x);
                            // }}
                          >
                            {x.cmsisdn}
                          </h4> */}
          <p>
            {/* {x.currentplan} */}
            {item?.cmsisdn} &nbsp; &nbsp; &nbsp; &nbsp; {item?.linetype}
          </p>
        </div>
      </div>

      {/* {x.NonAccountMsisdn == true ? (
                        <div
                          className="cs_toggle_btn"
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/icon/Delete.svg"
                            }
                            alt=""
                            title=""
                            onClick={() => {
                              primayChangeHandle(x);
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          className="cs_toggle_btn"
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <input
                            type="checkbox"
                            name="toggle"
                            id={"test_" + x.cmsisdn}
                            checked={x.IsPrimary}
                            onChange={() => {
                              if (x?.IsPrimary === true) {
                                if (customerprofile?.Msisdn === x?.msisdn) {
                                  return;
                                }
                              } else {
                                if (
                                  data?.response?.primarynumbermarked == true &&
                                  x?.IsPrimary == false &&
                                  customerprofile?.Msisdn === x?.msisdn
                                ) {
                                  return;
                                }
                              }

                              primayChangeHandle(x);
                            }}
                          ></input>
                          <label htmlFor={"test_" + x.cmsisdn}>&nbsp;</label>
                        </div>
                      )} */}
    </li>
  );
}
